/** @format */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HmfButtonComponent, HmfSidePanelComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronRight
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { ProductReviewsDataAccessModule } from '@product-reviews/data-access';
import { ReviewButtonComponentModule } from '../review-button/review-button.module';
import { ReviewContentListComponent } from './review-content-list.component';
import { ReviewInformationDrawerModule } from '../review-information-drawer/review-information-drawer.module';
import { ReviewQuestionsAndAnswersModule } from '../review-questions-and-answers/review-questions-and-answers.module';
import { ReviewsDrawerContainerModule } from '../reviews-drawer-container/reviews-drawer-container.module';
import { TrapFocusModule } from '../directive/trap-focus/trap-focus.module';

@NgModule({
	imports: [
		CommonModule,
		HmfButtonComponent,
		HmfSidePanelComponent,
		HomefieldIconLibraryModule,
		ProductReviewsDataAccessModule,
		ReviewButtonComponentModule,
		ReviewInformationDrawerModule,
		ReviewQuestionsAndAnswersModule,
		ReviewsDrawerContainerModule,
		TrapFocusModule
	],
	declarations: [ReviewContentListComponent],
	exports: [ReviewContentListComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReviewContentListModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconChevronRight]);
	}
}
